import Vue from 'vue'
import Compressor from 'compressorjs'


var manejarCambiosFirebase = function(listado, snapshot, filtro) {
	snapshot.docChanges().forEach( change => {
		if (filtro && !filtro(change)) {
			return
		}

		if (change.type === "added") {
			listado.push({ identificador: change.doc.id, datos: change.doc.data() })
		}
		if (change.type === "modified") {
			for (let i in listado) {
				if (listado[i].identificador === change.doc.id) {
					Vue.set(listado, i, { identificador: change.doc.id, datos: change.doc.data() })
					break
				}
			}
		}
		if (change.type === "removed") {
			for (let i in listado) {
				if (listado[i].identificador === change.doc.id) {
					Vue.delete(listado, i)
					break
				}
			}
		}
	})
}

var nombreDeArchivoDesdeStorage = function(url) {
	let U = new URL(url)
	let pdzs = U.pathname.split('%2F')
	return decodeURIComponent(pdzs.pop())
}

var imágenes = {
	construirVariantes: function(img) {
		if (!img) {
			return Promise.reject({ error: 'No se recibió la imagen o tiene un formato errado.' })
		}

		let P = new Promise((resolve, reject) => {

			let I = new Image()
			I.onload = function() {
				let rta = {
					ancho: this.naturalWidth || this.width,
					alto: this.naturalHeight || this.height
				}

				if (rta.ancho < 100 && rta.alto < 100) {
					reject({ error: 'Imagen no válida. Puede ser muy pequeña o tener un formato no válido.' })
				} else {
					resolve(rta)
				}
			}

			I.src = window.URL.createObjectURL(img)

		}).then(res => {

			let promesas = []
			promesas.push(this.redimensionar(img, 'miniatura', 100, 0.8))

			if (res.ancho >= 900 || res.alto >= 900) {
				promesas.push(this.redimensionar(img, 'mediano', 700, 0.8))
			}

			let tamañoMáximo = res.alto
			if (res.ancho > res.alto) {
				tamañoMáximo = res.ancho
			}
			if (tamañoMáximo > 2200) {
				tamañoMáximo = 2200
			}

			promesas.push(this.redimensionar(img, 'original', tamañoMáximo, 0.8))

			return Promise.all(promesas)

		}).then(imgns => {

			if (!imgns || !imgns.length || imgns.length < 2) {
				return Promise.reject({ error: '[5730] Ocurrió un error' })
			}

			let obj = {
				imagen: true,
				miniatura: null,
				mediana: null,
				original: null,
				peso: 0,
			}

			for (let o of imgns) {
				if (o.tipo === 'miniatura') {
					obj.peso = obj.peso + o.file.size
					//obj.fileMiniatura = o.file
					obj.miniatura = o.file
				} else if (o.tipo === 'mediano') {
					if (img.size > o.file.size) {
						obj.peso = obj.peso + o.file.size
						//obj.fileMediana = o.file
						obj.mediana = o.file
					} else {
						// Omitido porque es más grande que el original
					}
				} else if (o.tipo === 'original') {
					if (img.size > o.file.size) {
						obj.peso = obj.peso + o.file.size
						//obj.fileOriginal = o.file
						obj.original = o.file
					} else {
						// Original original porque no disminuyó de peso
						obj.peso = obj.peso + img.size
						//obj.fileOriginal = img
						obj.original = img
					}
				}
			}

			//if (!obj.fileOriginal || !obj.fileMiniatura) {
			if (!obj.original || !obj.miniatura) {
				return Promise.reject({ error: '[7832] Ocurrió un error' })
			}

			return Promise.resolve(obj)

		})

		return P
	},
	redimensionar: function(img, tipo, tamaño, calidad) {
		return new Promise((resolve, reject) => {
			new Compressor(img, {
				quality: calidad,
				width: tamaño,
				height: tamaño,
				success(res) {
					resolve({tipo: tipo, file: res})
				},
				error(err) {
					reject({error: err})
				}
			})
		})
	}
}

export { imágenes, manejarCambiosFirebase, nombreDeArchivoDesdeStorage }